import { Button } from "@ds/react";
import styled from "styled-components";

export const CancelarButton = styled(Button)({
  maxWidth: "300px",
});
